<template>
  <channel-tabbar :tabbarList="tabbarList" />
</template>
<script>
import qs from 'qs'
import ChannelTabbar from 'app/frontend-lib/component/vue/qingsu/ChannelTabbar'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ChannelTabbar
  },
  data() {
    return {
      orderBadge: '',
      mineBadge: ''
    }
  },
  computed: {
    cid() {
      return this.$route.query.cid || ''
    },
    tabbarList() {
      const { query } = this.$route
      return [
        {
          name: 'home',
          text: '倾诉',
          path: '/qingsu/channel',
          onChange: () => {
            if (this.disabled) return
            this.routerReplace({
              path: '/qingsu/channel',
              query
            })
          }
        },
        {
          name: 'order',
          text: '订单',
          path: '/qingsu-order-list',
          badge: this.orderBadge,
          onChange: () => {
            if (this.disabled) return

            this.trackH5Event('订单')
            this.routerReplace(
              {
                path: '/qingsu-order-list',
                query: {
                  filter: 'all',
                  from: 'all',
                  ...query
                }
              },
              `https://static.xinli001.com/msite/index.html`,
              'hash'
            )
          }
        },
        // 定制渠道特殊处理
        ...(+query.custom_channel
          ? []
          : [
              {
                name: 'mine',
                text: '我的',
                badge: this.mineBadge,
                path: '/consult/userCenter',
                onChange: () => {
                  if (this.disabled) return
                  this.trackH5Event('我的')
                  this.routerReplace(
                    'https://m.xinli001.com/consult/userCenter?' +
                      qs.stringify(query)
                  )
                }
              }
            ])
      ]
    }
  },
  methods: {
    trackH5Event(name) {
      const { cid = '', channel_flag = '' } = this.$route.query
      this.$trackEvent('listen_channel_buttonclick', {
        channel_id: cid || '',
        button_name: name ? name : '',
        channel_flag,
        cid
      })
    },
    setBadge(name, badge) {
      this[`${name}Badge`] = badge
    }
  }
}
</script>
